import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "C:\\website\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\website\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager" */ "C:\\website\\node_modules\\next\\dist\\client\\script.js");
